import { render } from "./FoodOrders.vue?vue&type=template&id=810730e4"
import script from "./FoodOrders.vue?vue&type=script&lang=js"
export * from "./FoodOrders.vue?vue&type=script&lang=js"

import "./FoodOrders.vue?vue&type=style&index=0&id=810730e4&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__